import { render, staticRenderFns } from "./TopSkillsSection.vue?vue&type=template&id=2b5537a9&scoped=true&"
import script from "./TopSkillsSection.vue?vue&type=script&lang=js&"
export * from "./TopSkillsSection.vue?vue&type=script&lang=js&"
import style0 from "./TopSkillsSection.vue?vue&type=style&index=0&id=2b5537a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5537a9",
  null
  
)

export default component.exports